import type { DataTableCellValue } from 'src/components/data-table/DataTable.types';

/**
 * Lightweight shared metadata for the TopBar search, kept free of React/RTK
 * imports so modules that only need the entity vocabulary (e.g. the entity
 * filter registry) don't pull the whole search implementation into their bundle.
 */
export type TopBarSearchEntityType =
    'instance' | 'addon' | 'user' | 'supportPackage' | 'workspace' | 'dataset';

/** Fixed render order for the grouped dropdown. */
export const TOP_BAR_SEARCH_GROUP_ORDER: readonly TopBarSearchEntityType[] = [
    'instance',
    'user',
    'addon',
    'workspace',
    'dataset',
    'supportPackage',
];

export type GlobalSearchFilters = Record<string, DataTableCellValue[] | undefined>;
